export const REGEX = {
  Email: /^[a-zA-Z0-9._]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  STRING_ONLY: /^[a-zA-Z ]*$/,
  NUMBERS_ONLY: /^[0-9]\d*(\.\d+)?$/,
  PASSWORD_PATTERN:
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.])[A-Za-z\d@$!%*?&.]{8,}$/,
  URLREGEX:
      /https?:\/\/(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}([a-zA-Z0-9-._~:/?#@!$&'()*+,;=%]*)?/
};
  